"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _runtime = require("../runtime");
var _default = exports.default = (0, _runtime.IconWrapper)('arrow_down_s', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("style", ['.kd-stroke-width-icon-bold{stroke-width:1.2px; stroke-width:var(--kd-stroke-width-icon-bold, 1.2px); }.kd-color-icon-secondary{fill:#757575; fill:var(--kd-color-icon-secondary, #757575); stroke:#757575; stroke:var(--kd-color-icon-secondary, #757575); }']), h("g", {
    "class": "kd-color-icon-secondary kd-stroke-width-icon-bold"
  }, [h("path", {
    "attrs": {
      "d": "M12 6.5L8.00718 10H7.99262L4 6.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "fill": "none",
      "vector-effect": "non-scaling-stroke"
    }
  })])]);
});